import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CRMService } from '../../services/crm.service';
import { CSEService } from '../../services/cse.service';
import { NotificationService } from '../../services/notification.service';
import {
    CustomerCarrierExclusionMap,
    CustomerLookup,
    SearchCustomer
} from '../../models/models';

@Component({
    selector: 'carrier-customer-exclusion-form',
    templateUrl: './carrier-customer-exclusion-form.component.html',
    standalone: false
})
export class CarrierCustomerExclusionForm implements OnChanges {
    @Input() customerCarrierExclusionMapID: number = 0;
    @Input() carrierID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public customerCarrierExclusionMap: CustomerCarrierExclusionMap = {} as CustomerCarrierExclusionMap;
    public customerList: SearchCustomer[] = [];
    public customer: SearchCustomer = {} as SearchCustomer;
    public customerID: number = 0;
    public isLoading: boolean = false;

    public formGroup: UntypedFormGroup = new UntypedFormGroup({
        customerCtrl: new UntypedFormControl('')
    });

    constructor(private crmService: CRMService, private cseService: CSEService, private notificationService: NotificationService) {
    }

    ngOnInit() {
        //console.log("ngOnInit", this.customerCarrierExclusionMapID, this.carrierID);
    }

    ngOnChanges() {
        this.getCustomerCarrierExclusionMap();
        //console.log("ngOnChanges", this.customerCarrierExclusionMapID, this.carrierID);
    }

    private getCustomerCarrierExclusionMap() {
        if (this.customerCarrierExclusionMapID > 0) {
            this.cseService.getCustomerCarrierExclusionMapByID(this.customerCarrierExclusionMapID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.customerCarrierExclusionMap = result.resultCollection[0];
                    this.customerID = this.customerCarrierExclusionMap.customerID;
                    this.getCustomer(this.customerID, "customer", false);
                }
            });
        }
        else {
            var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.customerCarrierExclusionMap = {
                customerCarrierExclusionMapID: 0,
                customerID: this.customerID,
                carrierID: this.carrierID,
                notes: "",
                createdByEmployeeID: employeeID,
                createdDate: new Date()
            };
        }
    }

    public onCustomerChange(evt: any, ctrl: string) {
        var selectedCustomer = this.formGroup.controls[ctrl].value as CustomerLookup;

        if (ctrl == "customerCtrl") {
            this.customer = {} as SearchCustomer;
            if (!isNaN(evt) && evt != null) {
                this.customerID = evt;
            }
            else {
                this.customerID = selectedCustomer.customerID;
            }
            this.getCustomer(this.customerID, "customer", true);
        }
        //console.log("carrier-customer-exclusion-form:onCustomerChange", ctrl, this.customerID, evt, selectedCustomer);
    }

    private getCustomer(customerID: number, customerType: string, isChange: boolean) {
        this.crmService.getSearchCustomerByID(customerID).subscribe(result => {
            var cust: SearchCustomer = result.resultCollection[0];
            if (customerType == "customer") {
                this.customer = Object.assign({}, cust);
                if (this.customerCarrierExclusionMap != null && isChange) {
                    this.customerCarrierExclusionMap.customerID = this.customerID;
                    this.checkCustomerCarrierExclusionMap();
                }
            }
            //console.log("carrier-customer-exclusion-form:getCustomer", customerID, customerType, this.customerID, this.customerCarrierExclusionMap);
        });
    }

    private checkCustomerCarrierExclusionMap() {
        this.isLoading = true;
        this.cseService.getCustomerCarrierExclusionMapByCustomerIDCarrierID(this.customerID, this.carrierID).subscribe(result => {
            this.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.customerCarrierExclusionMap = result.resultCollection[0];
                this.notificationService.showWarning("Found existing record. Loading record for edit.", "WARNING: Record Exists");
            }
        });
    }

    public save() {
        this.isLoading = true;
        console.log("save", this.customerCarrierExclusionMap);
        this.cseService.saveCustomerCarrierExclusionMap(this.customerCarrierExclusionMap).subscribe(result => {
            this.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
            }
        });

        this.customerCarrierExclusionMap = {} as CustomerCarrierExclusionMap;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}